import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="join-modal"
// Auto-opens the join modal when ?join=open query parameter is present
export default class extends Controller {
  static targets = ["trigger"]

  declare readonly hasTriggerTarget: boolean
  declare readonly triggerTarget: HTMLButtonElement

  connect() {
    // Check for ?join=open query parameter
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get("join") === "open") {
      // Small delay to ensure DOM is ready and WebAwesome is initialized
      setTimeout(() => {
        this.openModal()
      }, 100)
    }
  }

  openModal() {
    // Click the button with command="show-modal" commandfor="join-space-dialog"
    // This uses WebAwesome's declarative dialog system
    if (this.hasTriggerTarget) {
      this.triggerTarget.click()
    }
  }
}
